import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { useErrorStore } from '../../hooks/use-error-store/use-error-store';

import * as Styled from './error-message.styles';

export const ErrorMessage: FC = () => {
  const hideError = useErrorStore(({ hideError }) => hideError);
  const show = useErrorStore(({ show }) => show);
  const message = useErrorStore(({ message }) => message);

  return (
    <Styled.Feedback
      timeout={3000}
      variant="error"
      show={show}
      onExited={hideError}
    >
      <FormattedMessage id={message} defaultMessage={message} />
    </Styled.Feedback>
  );
};
